module.exports = __webpack_public_path__ + "img/rogers-waterfront.fcc501bc.webp";